import CommonAPIService from './CommonHandler';

export class LedgersAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

/**
 * Retrieves a ledger by its ID
 * @param {number} lid - The ledger ID
 * @param {Route} router - Vue router object for navigation and error handling
 * @returns {Promise<object>} Promise resolving to the ledger record
 * @example getByLid(123, router);
 */
  getByLid(lid, router){
    const fields = 'acct,amt,dep,due,lid,num,paid,pid,ledgers.note,ledgers.type,firms.fid,firms.sort,policies.expiry,firms.producer'
    const url = `/api/ledgers/${lid}?fields=${fields}`;
    return this.CommonAPIService.getCall(url, router);
  }

  getLedgers(pid,router) {
    const url = `/api/ledgers/?pid=${pid}`; //pass fields and filters for faster performance
    return this.CommonAPIService.getCall(url, router);
  }

  addLedger(ledgerData, router) {
    const url = '/api/ledgers';
    return this.CommonAPIService.postCall(url, ledgerData, router);
  }

  updateLedger(lid, ledgerData, router) {
    const url = `/api/ledgers/${lid}`;
    return this.CommonAPIService.putCall(url, ledgerData, router);
  }

  updateLedgersArray(ledgerData, router) {
    const url = '/api/ledgers';
    return this.CommonAPIService.putCall(url, ledgerData, router);
  }

  updateLedgersByPid(pid, ledgerData, router) {
    const url = `/api/ledgers?pid=${pid}`;
    return this.CommonAPIService.putCall(url, ledgerData, router);
  }

  updateLedgersByBulk(filtersObject, ledgerData, router) {
    //pass a filterObject such as {fid: number, cid: number, ...} and ledgerData such as {note: 'updated note', ...} to update all ledgers where the filters match
    const filters = new URLSearchParams(filtersObject).toString();
    const url = `/api/ledgers?${filters}`;
    return this.CommonAPIService.putCall(url, ledgerData, router);
  }

  ledgersSearch(searchObject, router) {
    // pass object such  {startDate: '06-12-2006',endDate:'06-12-2006', dateType: 'dep',type: 'Receipt', amount: '0 or less'};
    const filters = new URLSearchParams(searchObject).toString();
    const fields = 'acct,amt,dep,due,lid,num,paid,pid,ledgers.note,ledgers.type,firms.fid,firms.sort,policies.expiry,firms.producer';
    const url = `/api/ledgers/search?fields=${fields}&${filters}&withContactsSort=true`;
    return this.CommonAPIService.getCall(url, router);
  }

  /*
  * Delete ledger by lid
   * @param {number} lid - The ledger id
   * @param {Route} router - Object that contains information about the current route.
   * @returns {Promise<object>} - A promise consisting is the ledger was deleted
   * @example deleteLedger(123, router);
   */
  deleteLedger(lid, router) {
    const url = `/api/ledgers/${lid}`;
    return this.CommonAPIService.deleteCall(url, router);
  }

  /**
   * Retrieves all ledger accounts with zeroed balances
   * @param {Route} router - Vue router object for navigation and error handling
   * @returns {Promise<Array<{fid: number, pids: number[]}>>} Promise resolving to an array of firms
   * with their associated zeroed balance policy IDs
   * @example
   * // Response shape:
   * // [{ fid: 1, pids: [1, 2] }, ...]
   */
  getZerodBalances(router) {
    const url = '/api/ledgers/zeroed';
    return this.CommonAPIService.getCall(url, router);
  }
}

export default LedgersAPIService;
